import { render, staticRenderFns } from "./BaseModalConfirmDelete.vue?vue&type=template&id=d7dfdfa8&"
import script from "./BaseModalConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./BaseModalConfirmDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports